import React from 'react';
import { CircularProgress } from '@mui/material';

const SubmitButton = ({ children, onClick, disabled = false, loading = false, style = {} }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled || loading}
      style={{
        background: disabled && !loading
          ? '#cbd5e1'
          : loading
          ? '#cbd5e1'
          : 'linear-gradient(135deg, #FF7700, #FF8800)',
        color: '#000',
        border: 'none',
        padding: '14px 32px',
        fontSize: '1rem',
        fontWeight: 600,
        borderRadius: '10px',
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: disabled || loading ? 'none' : '0 4px 12px rgba(255,119,0,0.3)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        ...style,
      }}
    >
      {loading && (
        <CircularProgress size={18} thickness={5} style={{ color: '#475569' }} />
      )}
      <span>{children}</span>
    </button>
  );
};

export default SubmitButton;
